module.exports = __webpack_public_path__ + "static/media/MICHELL AUDIO GYRO TURNTABLE.7960a610.png";